<template>
  <div class="opc-storage-select">
    <zm-radio-group
      :model-value="value"
      enter-select
      aria-label="Select a storage plan"
      class="opc-card-radio opc-storage-select__radio-group"
      data-testid="simple-edit-storage-radio-group"
      @update:model-value="handleChange"
    >
      <zm-radio
        v-for="plan in options"
        :key="plan.capacity"
        :label="plan.capacity"
        :disabled="calculateIsOptionDisabled ? calculateIsOptionDisabled(plan) : false"
        :data-testid="`simple-edit-storage-radio-${plan.capacity}`"
      >
        <div class="opc-storage-select__radio-content">
          <div class="opc-storage-select__radio-header">
            <p class="opc-storage-select__radio-title">
              <span>{{ plan.cartCapacity }} {{ plan.cartCapacityUnit }}</span>
              <span class="opc-storage-select__radio-title-extra" v-if="plan.extra.title">{{ plan.extra.title }}</span>
              <CycleCurrentBadge :value="plan" />
              <span v-if="recommendedCapacity && recommendedCapacity.category === plan.category"
                class="opc-storage-select__badge-recommend">
                {{ $t('billing.cmr.recommended') }}
              </span>
            </p>
          </div>
          <div class="opc-storage-select__radio-price">
            <div class="opc-storage-select__price-main">{{ getFormattedPriceOfMonthWithDownsell(plan, { forceDiff: true }) }}</div>
            <div class="opc-storage-select__price-unit">
              <span v-html="getMergedBilledText(plan.billing_cycle, plan.amount, planUnit)"></span><priceVATTip />
            </div>
          </div>
        </div>
      </zm-radio>
    </zm-radio-group>
    <div class="opc-storage-select__footer" v-if="$slots.footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import CycleCurrentBadge from '@/components/service/config-billing-cycle/cycle-current-badge.vue';
import discountedMonthPrice from '@/common/mixin/discounted-month-price';
import { planUnitMap } from '@/common/product-unit';

export default {
  name: 'StorageSelect',
  mixins: [discountedMonthPrice],
  components: {
    CycleCurrentBadge,
  },
  props: {
    value: Number,
    options: {
      type: Array,
      default: () => [],
    },
    planUnit: {
      type: Number,
      default: planUnitMap.credits,
    },
    recommendedCapacity: {
      type: Object,
      default: null,
    },
    calculateIsOptionDisabled: {
      type: Function,
      default: null,
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/scss-utils';
@import '@/styles/variables';
@import '@/styles/zoom-card.scss';

.opc-storage-select {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  width: 100%;

  &__radio-group {
    width: 100%;
    flex-wrap: wrap;

    ::v-deep .zbo-radio {
      flex: 1 0 0;
      min-width: calc(50% - 8px);
      margin-right: 0;

      @include media(mobile) {
        min-width: 100%;
      }

      &__wrap {
        width: 100%;
      }

      &__label--inner {
        width: 100%;
        padding: 12px;
      }
    }
  }

  &__radio-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__radio-header {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
    padding-right: 16px;
    margin-bottom: 4px;
  }

  &__radio-title {
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.31px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    color: var(--text-text-stronger-neutral, #2A2B2D);
    font-style: normal;
    font-weight: 400;
  }

  &__radio-title-extra {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: var(--text-subtle-neutral, #686f79);
  }

  &__badge-recommend {
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(96.59deg, #084845 10.36%, #09A639 89.64%);
    border-radius: 100px;
    padding: 0px 8px;
    color: #FFFFFF;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }

  &__radio-price {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    gap: 2px;
  }

  &__price-main {
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    letter-spacing: -0.41px;
  }

  &__price-unit {
    color: var(--text-text-stronger-neutral, #2A2B2D);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  &__footer {
    width: 100%;
    margin-top: 8px;
  }
}
</style>

